import { StepsStyleType } from './steps-style.type';
import { StepsDarkTheme } from './steps.dark-theme';

export const StepsLightTheme: StepsStyleType = StepsDarkTheme;
